import { render, staticRenderFns } from "./SCButtonGroup.vue?vue&type=template&id=55a9cacf&scoped=true&"
var script = {}
import style0 from "./SCButtonGroup.vue?vue&type=style&index=0&id=55a9cacf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a9cacf",
  null
  
)

export default component.exports